<template>
    <div style="background-color: white; padding: 15px;">
        <div class="title"><b>{{$translation($websiteText().QA_title)}}</b> </div>
        <template v-for="QA in QAs" :key="QA.id"  >
            <div class="question-answer" v-if="QAs.length > 0">
                <li class="question">
                    {{ QA.question }}
                </li>
                <div class="answers">
                    <template v-if="QA.answers.length">
                        <template v-for="answer in QA.answers" :key="answer.id">
                            {{ answer.answer }}
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="isBuyer || !$store.getters.customer">
                            {{$translation($websiteText().QA_seller_did_not_answer)}}
                        </template>
                        <template v-else>
                            <template v-if="QA.is_approved">
                                <div class="input-btn">
                                    <TInputText
                                        :placeholder="$translation($websiteText().QA_answer_question)"
                                        v-model="answer[QA.id]"
                                    />
                                    <TButton
                                        :label="$translation($websiteText().QA_reply)"
                                        @click="submitAnswerToQuestion(QA.id)"
                                        color="primary-color-medium"
                                    />
                                </div>
                            </template>
                        </template>
                    </template>
                </div>
            </div>
        </template>
        <template v-if="isBuyer">
            <div class="question" v-if="QAs.length > 0" > {{ $translation($websiteText().QA_did_not_find_answer) }}</div>
            <div class="input-btn">
                <TInputText
                    :placeholder="$translation($websiteText().QA_ask_question)"
                    v-model="question"
                />
                <TButton
                    :label="$translation($websiteText().QA_submit)"
                    @click="submitQuestion()"
                    color="primary-color-medium"
                />
            </div>
        </template>
    </div>
</template>

<script>
import TInputText from '../../../common/components/input-text/TInputText.vue';
import TButton from '../../../common/components/buttons/TButton.vue';
import { ADD_ANSWER, ADD_QUESTION, GET_KIT_QA } from '../store/actions';
import { SHOW_TOAST_MESSAGE } from '../../../common/store/actions';
import GeneralHelper from '../../../common/helpers/GeneralHelper';
export default {
    components:{TInputText, TButton},
    props:{
        QAs:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return {
            question:'',
            answer:{}
        }
    },
    methods:{
        submitQuestion()
        {
            let data = {
                'kit_id':this.$store.getters.productDetailsInfos.id,
                'question':this.question
            }
            let that = this
            this.$store.dispatch(ADD_QUESTION,data).then(
                (response)=>{
                    that.$store.dispatch(GET_KIT_QA,that.$store.getters.productDetailsInfos.id)
                    that.$store.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(1, "Question Submitted Succesfully"))
                }
            )
            this.question = ""
        },
        submitAnswerToQuestion(id)
        {
            let data = {
                'question_id':id,
                'answer':this.answer[id]
            }
            this.answer[id] = ''
            this.$store.dispatch(ADD_ANSWER,data).then(
                (response)=>{
                    that.$store.dispatch(GET_KIT_QA,that.$store.getters.productDetailsInfos.id)
                    that.$store.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(1, "Answer Submitted Succesfully"))
                }
            )

        }
      
    },
    computed:{
        isBuyer()
        {
            return !this.$store.getters.customer||(this.$store.getters.customer&&this.$store.getters.productDetailsInfos.sellerId != this.$store.getters.customer.id)
        }
    }
}

</script>


<style lang="scss" scoped>

    .title {
        //@include f-page-title-home;
        @include f-footer;
        font-size: 15px;
        color: black;
        margin-bottom: 15px;
    }
    .question-answer{
        margin-bottom: 20px;

        .answers{
            @include f-footer;
            font-weight: 400;
            margin-left: 20px;
        }
        .question {
            @include f-footer;
            font-weight: 700;
            color: black;
        }
    }

    .input-btn{
        margin-top: 5px;
        //display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
</style>